import { useQuery } from "@tanstack/react-query";
import { Star } from "lucide-react";
import { getTestimonials } from "@/lib/api";
import { Reveal } from "@/lib/motion";
import { PageHero, GoldLink } from "@/components/ui-kit";
import { useSeo } from "@/lib/useSeo";
import { BUSINESS } from "@/lib/config";

export default function Testimonials() {
  useSeo({ title: "Testimonials", description: "Read what Sutra Interio's homeowners say about our boutique interior design service." });
  const { data: items = [] } = useQuery({ queryKey: ["testimonials"], queryFn: getTestimonials });

  return (
    <div data-testid="testimonials-page">
      <PageHero overline="Client Stories" title="Trusted by families" italic="across Kolkata."
        sub={`Rated ${BUSINESS.rating}/5 across ${BUSINESS.reviewCount}+ reviews.`} />

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-16">
        <div className="grid md:grid-cols-2 gap-6">
          {items.map((t, i) => (
            <Reveal key={t.name} delay={(i % 2) * 0.08} className="bg-cream border border-gold/20 rounded-md p-8 md:p-10">
              <div className="flex gap-1 text-gold">{Array(t.rating).fill(0).map((_, k) => <Star key={k} size={16} fill="currentColor" />)}</div>
              <p className="font-display text-2xl md:text-3xl leading-snug mt-5 text-ink/90">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-6 flex items-center gap-4">
                <div className="w-11 h-11 rounded-full bg-bronze/15 grid place-items-center font-display text-xl text-bronze">{t.name[0]}</div>
                <div>
                  <p className="font-medium">{t.name}</p>
                  <p className="text-ink/50 text-sm">{t.project} · {t.location}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-6 md:px-10 pb-24 text-center">
        <Reveal><GoldLink href={BUSINESS.googleReviewsUrl} testid="google-reviews-link">Read our Google Reviews</GoldLink></Reveal>
      </section>
    </div>
  );
}
